module.exports = __webpack_public_path__ + "static/slomo-bird-9079982ffa00258f388dc58fb8a82f62.mp4";